/* Vionine — sepet ilerleme satirlari (mokap: Sepet Mokap.dc.html, onaylandi 23.09).
   1) Buy 3, Pay for 2: sepetteki adet 3'e ulasana kadar kalan adet.  2) Ucretsiz kargo: $30'a kalan tutar.
   Indirimi UYGULAMAZ — Shopify otomatik indirimi odemede uygular; burada yalnizca bilgi verilir.
   Sepet sayfasi: [data-vio-cart-progress] kutusunu doldurur.
   Mini sepet (Gecko): #t4s-mini_cart icinde basligin altina, form.t4s-drawer__wrap'in onune eklenir.
   Gecko sepet her guncellendiginde drawer icerigini yeniden cizer; MutationObserver kutuyu tekrar ekler.
   Ayarlar: NEED (adet), FREE_CENTS (kargo baraji, sent).
   02.11: window.vioB3 === false ise (Tema ayarlari > Buy 3, Pay 2 kapali) yalnizca ucretsiz kargo satiri gosterilir. */
(function () {
  var NEED = 3, FREE_CENTS = 3000;
  var CSS = '.vcp{display:grid;gap:10px;margin:0 0 18px}.vcp--page{grid-template-columns:1fr 1fr}.vcp__box{background:#F3EFF9;border-radius:6px;padding:12px 14px;display:flex;flex-direction:column;gap:7px}.vcp__t{margin:0;font-size:13.5px;line-height:1.45;color:#322E39}.vcp__t strong{font-weight:600}.vcp__bar{height:6px;background:#E9E4EF;border-radius:3px;overflow:hidden}.vcp__fill{height:100%;background:#7A5AA6;transition:width .4s ease}.vcp__fill--ship{background:#1E7A52}.vcp__s{margin:0;font-size:12px;color:#736D79}.vcp--drawer{margin:0;padding:12px 20px;background:#F3EFF9;gap:10px;border-bottom:1px solid #E9E4EF}.vcp--drawer .vcp__box{padding:0;background:none}@media(max-width:767px){.vcp--page{grid-template-columns:1fr}}';
  function style() { if (document.getElementById('vcp-css')) return; var s = document.createElement('style'); s.id = 'vcp-css'; s.textContent = CSS; document.head.appendChild(s); }
  function money(c, cur) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD' }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } }
  function html(cart, mode) {
    var n = cart.item_count, total = cart.total_price, cur = cart.currency;
    var left = Math.max(0, NEED - n), pctA = Math.min(100, n / NEED * 100);
    var gap = Math.max(0, FREE_CENTS - total), pctB = Math.min(100, total / FREE_CENTS * 100);
    var a = left > 0
      ? '<strong>Buy 3, Pay for 2.</strong> Add ' + left + ' more item' + (left > 1 ? 's' : '') + ' and the lowest-priced one is free.'
      : '<strong>Buy 3, Pay for 2 unlocked.</strong> The lowest-priced item is free at checkout.';
    var b = gap > 0 ? 'You are <strong>' + money(gap, cur) + '</strong> away from free U.S. shipping.' : '<strong>Free U.S. shipping unlocked.</strong>';
    var sub = mode === 'page';
    if (window.vioB3 === false) {
      return '<div class="vcp__box" style="grid-column:1/-1"><p class="vcp__t">' + b + '</p><div class="vcp__bar"><div class="vcp__fill vcp__fill--ship" style="width:' + pctB + '%"></div></div>' + (sub ? '<p class="vcp__s">Free shipping at ' + money(FREE_CENTS, cur) + '</p>' : '') + '</div>';
    }
    return '<div class="vcp__box"><p class="vcp__t">' + a + '</p><div class="vcp__bar"><div class="vcp__fill" style="width:' + pctA + '%"></div></div>' + (sub ? '<p class="vcp__s">' + Math.min(n, NEED) + ' of ' + NEED + ' items</p>' : '') + '</div>' +
           '<div class="vcp__box"><p class="vcp__t">' + b + '</p><div class="vcp__bar"><div class="vcp__fill vcp__fill--ship" style="width:' + pctB + '%"></div></div>' + (sub ? '<p class="vcp__s">Free shipping at ' + money(FREE_CENTS, cur) + '</p>' : '') + '</div>';
  }
  function drawerRoot() {
    return document.getElementById('t4s-mini_cart') || document.querySelector('[data-cart-wrapper]') || document.getElementById('shopify-section-mini_cart');
  }
  function drawerTarget() {
    var d = drawerRoot();
    if (!d) return null;
    var box = d.querySelector('.vcp--drawer');
    if (box) return box;
    var form = d.querySelector('form.t4s-drawer__wrap') || d.querySelector('.t4s-drawer__wrap') || d.querySelector('form');
    if (!form || !form.parentNode) return null;
    box = document.createElement('div');
    box.className = 'vcp vcp--drawer';
    box.setAttribute('aria-live', 'polite');
    form.parentNode.insertBefore(box, form);
    return box;
  }
  var last = null, busy = false, again = false;
  function paint(cart) {
    style();
    var page = document.querySelector('[data-vio-cart-progress]');
    if (page) { page.className = 'vcp vcp--page'; page.innerHTML = cart.item_count ? html(cart, 'page') : ''; }
    var dr = drawerTarget();
    if (dr) { dr.innerHTML = cart.item_count ? html(cart, 'drawer') : ''; dr.style.display = cart.item_count ? '' : 'none'; }
  }
  function run() {
    if (busy) { again = true; return; } busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      last = cart; paint(cart);
    }).catch(function () {}).then(function () { busy = false; if (again) { again = false; setTimeout(run, 150); } });
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(run, 250); }
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      var el = m[i].target;
      if (el.nodeType !== 1) continue;
      if (el.closest && el.closest('.vcp')) continue;
      var d = drawerRoot();
      if ((d && d.contains(el)) || (el.closest && el.closest('[data-cart-items],[id*="cart"],[class*="cart"]'))) {
        if (last && d && !d.querySelector('.vcp--drawer')) paint(last);
        later();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', later);
  document.addEventListener('cart:updated', later);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-drawer-options*="mini_cart"],[data-cart-toggle],a[href$="/cart"],.t4s-site-nav__cart')) setTimeout(run, 400); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
